/**
 * Public marketing news (/latestnews, /newsDetails). Admin /admin/blogs is unaffected.
 * Off by default. Set REACT_APP_ENABLE_PUBLIC_NEWS=true to show news on the public site.
 */
export const isPublicNewsEnabled =
  process.env.REACT_APP_ENABLE_PUBLIC_NEWS === "true";
